(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const addUrl = root + 'cart/add.js';
  const updateUrl = root + 'cart/update.js';
  const cartUrl = root + 'cart.js';

  function getCart() {
    return fetch(cartUrl).then(function (r) { return r.json(); });
  }

  async function addVariant(id) {
    const res = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer'
      })
    });
    return res.json();
  }

  async function applyDiscount(code) {
    const res = await fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: String(code || '') })
    });
    const data = await res.json();
    if (data.status && data.status >= 400) {
      throw new Error(data.description || data.message || 'Discount failed');
    }
    return data;
  }

  function codeApplied(cart, code) {
    const want = String(code || '').trim().toUpperCase();
    if (!want || !cart) return false;
    const list = cart.discount_codes || cart.cart_level_discount_applications || [];
    return list.some(function (d) {
      const name = String(d.code || d.title || '').toUpperCase();
      return name === want && d.applicable !== false;
    });
  }

  function applySections(sections) {
    if (!sections) return;
    const parse = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
    if (sections['cart-drawer']) {
      const doc = parse(sections['cart-drawer']);
      const inner = document.querySelector('cart-drawer .drawer__inner');
      const next = doc.querySelector('.drawer__inner') || doc.querySelector('#CartDrawer');
      if (inner && next) inner.innerHTML = (next.querySelector('.drawer__inner') || next).innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      const doc = parse(sections['cart-icon-bubble']);
      const cur = document.getElementById('cart-icon-bubble');
      const fresh = doc.getElementById('cart-icon-bubble') || doc.body.firstElementChild;
      if (cur && fresh) cur.innerHTML = fresh.innerHTML;
    }
    if (sections['main-cart-items']) {
      const doc = parse(sections['main-cart-items']);
      const page = document.getElementById('main-cart-items');
      const fresh = doc.getElementById('main-cart-items') || doc.querySelector('.shopify-section');
      if (page && fresh) page.innerHTML = fresh.innerHTML;
    }
    if (sections['main-cart-footer']) {
      const doc = parse(sections['main-cart-footer']);
      const page = document.getElementById('main-cart-footer');
      const fresh = doc.getElementById('main-cart-footer') || doc.querySelector('.shopify-section');
      if (page && fresh) page.innerHTML = fresh.innerHTML;
    }
  }

  function refreshCartUI(sectionsFromAdd) {
    if (sectionsFromAdd) {
      applySections(sectionsFromAdd);
      initCarousels();
      openCartDrawer();
      return Promise.resolve();
    }
    return fetch('/?sections=cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        applySections(data);
        initCarousels();
      })
      .catch(function () {
        if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
      });
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  function shuffle(nodes) {
    const arr = Array.from(nodes);
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function initCarousels() {
    document.querySelectorAll('[data-lc-carousel]').forEach(function (el) {
      el.dataset.lcReady = '';
      const track = el.querySelector('.lc-upsells__track');
      const dotsWrap = el.querySelector('[data-lc-dots]');
      if (!track) return;
      const ordered = shuffle(track.children);
      ordered.forEach(function (n) { track.appendChild(n); });
      const slides = Array.from(track.children);
      if (!slides.length) { el.style.display = 'none'; return; }
      let index = 0;
      function renderDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = slides.map(function (_, i) {
          return '<button type="button" data-i="' + i + '"' + (i === index ? ' class="is-on"' : '') + '></button>';
        }).join('');
      }
      function go(n) {
        index = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + index * 100 + '%)';
        renderDots();
      }
      const prev = el.querySelector('[data-lc-prev]');
      const next = el.querySelector('[data-lc-next]');
      if (prev) prev.onclick = function () { go(index - 1); };
      if (next) next.onclick = function () { go(index + 1); };
      if (dotsWrap) dotsWrap.onclick = function (e) {
        const b = e.target.closest('button[data-i]');
        if (b) go(Number(b.dataset.i));
      };
      go(0);
    });
  }

  function couponMsg(wrap, text, ok) {
    const el = wrap.querySelector('.lc-coupon__msg');
    if (!el) return;
    el.hidden = !text;
    el.textContent = text || '';
    el.classList.toggle('is-ok', !!ok);
    el.classList.toggle('is-err', !ok);
  }

  async function runCoupon(wrap, code) {
    if (!wrap || !code) return;
    const btn = wrap.querySelector('[data-lc-coupon-apply]');
    if (btn) btn.disabled = true;
    couponMsg(wrap, 'Applying…', true);
    try {
      const before = await getCart();
      await applyDiscount(code);
      let after = await getCart();
      if (!codeApplied(after, code)) {
        await fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'follow' });
        after = await getCart();
      }
      if (codeApplied(after, code) || after.total_discount > before.total_discount) {
        await refreshCartUI();
      } else {
        couponMsg(wrap, 'Code could not be applied.', false);
      }
    } catch (err) {
      couponMsg(wrap, err.message || 'Code could not be applied', false);
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-add]');
    if (!btn) return;
    const row = btn.closest('.lc-upsell');
    if (!row) return;
    e.preventDefault();
    const select = row.querySelector('.lc-upsell__variant');
    const id = select && select.value;
    if (!id) return;
    btn.disabled = true;
    try {
      const data = await addVariant(id);
      await refreshCartUI(data && data.sections);
    } finally {
      btn.disabled = false;
    }
  });

  document.addEventListener('click', function (e) {
    const applyBtn = e.target.closest('[data-lc-coupon-apply]');
    if (!applyBtn) return;
    e.preventDefault();
    const wrap = applyBtn.closest('[data-lc-coupon]');
    const input = wrap && wrap.querySelector('.lc-coupon__input');
    runCoupon(wrap, input && input.value.trim());
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    const input = e.target.closest('.lc-coupon__input');
    if (!input) return;
    e.preventDefault();
    runCoupon(input.closest('[data-lc-coupon]'), input.value.trim());
  });

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-lc-coupon-remove]');
    if (!btn) return;
    btn.disabled = true;
    try {
      await applyDiscount('');
      await refreshCartUI();
    } finally {
      btn.disabled = false;
    }
  });

  if (window.subscribe && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(initCarousels, 80); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
})();